import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab } from "@material-ui/core";
import CutList from "./CutList/CutList";
import UsedItems from "./UsedItems/UsedItems";
import QualityControl from "./QualityControl/QualityControl";
import { read } from "Helpers/LocalStorage";
import { getProjectBuildInfo, insertBuiltData } from "Stores/actions";
import { Grid } from "@material-ui/core";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import ConstructionTable from "./components/ConstructionTable";
import MuiButton from "Components/MuiButton/MuiButton";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { checkTabPage } from "./components/checkTabPage";
import PreviewDialog from "./components/PreviewDialog";
import Translator from "Languages/Utility/Translator";
import {
  CONSTRUCTION_ID_PROJECTS,
  CONSTRUCTION_RESULT,
  CONSTRUCTION_SENDER,
} from "Stores/actionTypes";
import Optimize from "./Optimize/Optimize";
//icons
import boreshIcon from "Assets/svg/construction/boreshIcon.svg";
import optGalvanize from "Assets/svg/construction/optGalvanize.svg";
import masrafiIcon from "Assets/svg/construction/masrafiIcon.svg";
import qualitiCheck from "Assets/svg/construction/qualitiCheck.svg";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";
import PageTitle from "Components/PageTitle/PageTitle";
import CountManagerDialog from "./components/CountManagerDialog";

const Construction = (props) => {
  const { t } = useTranslation();
  const { selectedProject, constructionResult, constructionPagination } =
    useSelector((state) => ({
      selectedProject: state.project.selectedProject,
      constructionResult: state.construction.constructionResult,
      constructionPagination: state.construction.constructionPagination,
    }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [setFirstData, setSetFirstData] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("cut-list");
  const [defaultProjectId, setDefaultProjectId] = useState([]);
  const [extraIdProjects, setExtraIdProjects] = useState([]);
  const [totalProjectIds, setTotalProjectIds] = useState([]);
  const [sendData, setSendData] = useState({});

  useEffect(() => {
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        isConectorSash: false,
        isFitting: false,
        isFrame: true,
        isGlass: false,
        isGlazing: false,
        isInterLock: false,
        isMulion: false,
        isNet: false,
        isOther: false,
        isOtherPop: false,
        isOtherRail: false,
        isPanel: false,
        isProfile: false,
        isProfileKomaki: false,
        isRokob: false,
        isSash: true,
        isSashDoor: false,
        lenBranch: 6000,
        ListUnitId: [],
        CheckAll: true,
        isBeforeOptimal: false,
        action: 1,
        Extra_CutList: { value: 1, key: "Profile" },
        Extra_OptimizeGalvanize: { value: 9, key: "graphically" },
        Extra_OptimizeProfile: { value: 6, key: "graphically" },
        Extra_QualityControl: { value: 19, key: "unit_images" },
        Extra_UsedItems: { value: 12, key: "general_consumable" },
      },
    });
    setSetFirstData(true);
  }, []);

  useEffect(() => {
    let IdProjects = [];
    if (tab === "optimize") {
      IdProjects = defaultProjectId.concat(extraIdProjects);
    } else {
      IdProjects = defaultProjectId;
    }
    if (totalProjectIds.length === 0) {
      setTotalProjectIds(IdProjects);
    } else {
      if (
        totalProjectIds.length !== IdProjects.length ||
        !IdProjects.every((key, index) => totalProjectIds[index] === key)
      ) {
        setTotalProjectIds(IdProjects);
      }
    }
  }, [defaultProjectId, extraIdProjects, tab]);

  useEffect(() => {
    (async () => {
      if (totalProjectIds.length > 0) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdProjects: totalProjectIds,
            IdProject: 0,
            Limit: constructionPagination.Limit,
            Page: 1,
          };
          await dispatch(getProjectBuildInfo(data));
          dispatch({
            type: CONSTRUCTION_ID_PROJECTS,
            idProjects: defaultProjectId,
            additionalIdProjects: extraIdProjects,
          });
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else if (selectedProject) {
        setDefaultProjectId([selectedProject.Id]);
        setExtraIdProjects([]);
      }
    })();
  }, [totalProjectIds]);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const otherConstructionResult = {};
    Object.entries(constructionResult).forEach(([key, val]) => {
      if (key !== "ListUnitId" && !key.includes("Extra") && key !== "pageIndex")
        otherConstructionResult[key] = val;
    });
    const reListUnitId = totalProjectIds
      .map((id) => {
        let genData = constructionResult.ListUnitId.filter(
          (item) => item.ProjectId === id,
        );
        return genData.map((item) => item.unitId);
      })
      .flat();
    setSendData({
      ...otherConstructionResult,
      ListUnitId: reListUnitId,
    });

    dispatch({
      type: CONSTRUCTION_SENDER,
      constructionSender: {
        ...otherConstructionResult,
        ListUnitId: reListUnitId,
        IdProjects: totalProjectIds,
      },
    });
  }, [totalProjectIds, constructionResult]);

  const onClick = async (newList = null) => {
    console.log("onClick",newList );
    const tabPage = checkTabPage(tab);
    try {
      setLoading(true);
      let data = {
        ...sendData,
        IdProjects: totalProjectIds,
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        TabPage: tabPage !== -1 ? tabPage : constructionResult.pageIndex,
      };
      if (newList) {
        data = {
          ...data,
          optimalProfile: { ...newList },
          isBeforeOptimal: false,
        };
      }
      const response = await dispatch(insertBuiltData(data));
      if (response) {
        if ([3, 28, 29].includes(+sendData.action)) {
          const link = document.createElement("a");
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            response.Stream;
          link.setAttribute("download", response.Name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setOpen(true);
          setData(response);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const addProject = (id) => {
    if (extraIdProjects.length === 0) {
      setExtraIdProjects([id]);
    } else {
      let ids = [...extraIdProjects];
      if (!ids.some((x) => x === id)) {
        ids.push(id);
        setExtraIdProjects(ids);
      }
    }
  };

  const deleteProject = (id) => {
    if (extraIdProjects.length !== 0) {
      let ids = [...extraIdProjects];
      if (ids.some((x) => x === id)) {
        ids.pop(id);
        setExtraIdProjects(ids);
      }
    }
  };

  const handleChange = (event, newTab) => {
    setTab(newTab);
  };

  const handlePartChange = async (newList) => {
    onClick(newList);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      {setFirstData && (
        <>
          <PreviewDialog
            open={open}
            handleClose={handleClose}
            data={data}
            shareable={true}
          />
          <div className="page-top-title-button my-2">
            <PageTitle title={<Translator id="construction" />} />
            <div className="top-buttons">
              <CountManagerDialog onChange={handlePartChange} />
              <MuiButton
                color="primary"
                className="my-2"
                title={
                  <>
                    {[3, 28, 29].includes(+sendData.action) ? (
                      <Translator id="fileDownload" />
                    ) : (
                      <Translator id="preview" />
                    )}
                    {
                      <span className="me-1">
                        {`(${
                          constructionResult.CheckAll
                            ? constructionPagination.Total
                            : constructionResult.ListUnitId.length
                        } ${t("units")})`}
                      </span>
                    }
                  </>
                }
                onClick={() => onClick()}
                disabled={
                  !(sendData.ListUnitId.length > 0 || sendData.CheckAll)
                }
              />
            </div>
          </div>

          <TabContext value={tab}>
            <Box>
              <TabList onChange={handleChange} variant="scrollable">
                <Tab
                  icon={<ReactSVG src={boreshIcon} />}
                  label={t("ListBoresh")}
                  value="cut-list"
                />
                <Tab
                  icon={<ReactSVG src={optGalvanize} />}
                  label={t("optimization")}
                  value="optimize"
                />
                <Tab
                  icon={<ReactSVG src={masrafiIcon} />}
                  label={t("AglamMasrafi")}
                  value="used-items"
                />
                <Tab
                  icon={<ReactSVG src={qualitiCheck} />}
                  label={t("controlkeyfiat")}
                  value="quality-control"
                />
              </TabList>
            </Box>
            <MuiPaper className="w-100 mb-3">
              <TabPanel value="quality-control" className="p-0 m-0 ">
                <QualityControl />
              </TabPanel>
              <TabPanel value="used-items" className="p-0 m-0">
                <UsedItems />
              </TabPanel>
              <TabPanel value="optimize" className="p-0 m-0">
                <Optimize />
              </TabPanel>
              <TabPanel value="cut-list" className="p-0 m-0">
                <CutList />
              </TabPanel>
            </MuiPaper>
          </TabContext>
          <Grid item xs={12}>
            <ConstructionTable
              idProjects={totalProjectIds}
              tab={tab}
              addProject={addProject}
              deleteProject={deleteProject}
              parentLoading={loading}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default Construction;
